var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.622 10.587L4.25 6.834A.5.5 0 014.622 6h6.754a.5.5 0 01.372.835l-3.382 3.752a.5.5 0 01-.744 0z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNNy42MjI0NCAxMC41ODY4TDQuMjQ5NzggNi44MzQzMUMzLjk2MDUyIDYuNTEyNDcgNC4xODg5MyA2LjAwMDA4IDQuNjIxNjYgNi4wMDAwOEgxMS4zNzYzQzExLjgwOTMgNi4wMDAwOCAxMi4wMzc2IDYuNTEzMTMgMTEuNzQ3NyA2LjgzNDgyTDguMzY1NzMgMTAuNTg3M0M4LjE2Njk2IDEwLjgwNzkgNy44MjA5MSAxMC44MDc2IDcuNjIyNDQgMTAuNTg2OFoiIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1vcGFjaXR5PSIwLjkiLz4KPC9zdmc+";
export { SvgChevron as ReactComponent };